module.exports = __webpack_public_path__ + "static/media/logo2.0ce7fde1.svg";